import { TICKS_PER_BEAT } from '../../shared/tempo';
import type { EnemyDefinition } from '../types';

export interface HeatEffect {
  readonly kind: 'heat';
  readonly radius: number;
  readonly damage: number;
}

export const CANICULE: EnemyDefinition = {
  id: 'canicule',
  name: 'La Canicule',
  description: "Elle brûle qui n'est pas à l'ombre.",
  behaviour: 'boss',
  maxHp: 2000,
  speed: 0.7,
  radius: 44,
  damage: 30,
  attackCooldownTicks: 2 * TICKS_PER_BEAT,
  aggroRadius: 320,
  vibesDrop: 50,
  scalingPerPhrase: { hp: 1, speed: 1 },
  special: { kind: 'heat', radius: 150, damage: 3 },
};
